module.exports = __webpack_public_path__ + "static/media/Arial_Rounded_MT_Bold.0a705a1f.svg";